// import React from 'react'
// import NSPTagPage from '@/pages/AndroidDevice/NSPTag'
import PFTagPage from '@/pages/AndroidDevice/PFTag'
import PFItemSortPage from '@/pages/AndroidDevice/PFItemSort'
import PFRFIDScanPage from '@/pages/AndroidDevice/rfid/scan'
import FullTagPage from '@/pages/AndroidDevice/FullTag'
import OverdueValidationPage from '@/pages/AndroidDevice/rfid/overdueValidation'
import QrCodeBindingPage from '@/pages/AndroidDevice/qrCode/binding'
import rfIdScanningPage from '@/pages/AndroidDevice/qrCode/rfIdScan'
import QrCodeUnbindByCartonPage from '@/pages/AndroidDevice/qrCode/unbindByCarton'
import QrCodeUnbindBySoPage from '@/pages/AndroidDevice/qrCode/unbindBySo'
import QrCodeUnbindByPiecePage from '@/pages/AndroidDevice/qrCode/unbindByPiece'
import ReprintHoneywellPage from '@/pages/AndroidDevice/reprint/printHoneywell'
import ReprintSCPage from '@/pages/AndroidDevice/reprint/printSC'

import SkuCheckHoneywellPage from '@/pages/AndroidDevice/skuCheck/skuCheckHoneywell'
import SkuCheckScPage from '@/pages/AndroidDevice/skuCheck/skuCheckSC'

// 内网访问路由
export const phoneRouterConfigIn = [
  {
    key: '/rf/fulltag',
    label: 'FULL TAG',
    labelEn: 'FULL TAG',
    labelZh: 'FULL绑定',
    hidden: false,
    permission: ['menu_nfc_tag_fullTag'],
    component: FullTagPage
  },
  {
    key: '/rf/nddctag',
    label: 'NDDC TAG',
    labelEn: 'NDDC TAG',
    labelZh: 'NDDC绑定',
    hidden: false,
    permission: ['menu_nfc_tag_nddcTag'],
    component: PFTagPage
  },
  {
    key: '/rf/nddcsort',
    label: 'NDDC Item Sort',
    labelEn: 'NDDC Item Sort',
    labelZh: 'NDDC分拣',
    hidden: false,
    permission: ['menu_nfc_tag_nddcItemSort'],
    component: PFItemSortPage
  },
  {
    key: '/rfrfid/scan',
    label: 'Grey Market Scan',
    labelEn: 'Grey Market Scan',
    labelZh: 'Grey Market 扫描',
    hidden: false,
    permission: ['menu_greyMarke_greyMarketScan'],
    component: PFRFIDScanPage
  },
  {
    key: '/rfrfid/overdueValidation',
    label: 'Grey Market Scan',
    labelEn: 'WS Defective Return Overdue Validation',
    labelZh: 'WS 残次品退货超期检验',
    hidden: false,
    permission: ['menu_rfid_dr_ws_validation'],
    component: OverdueValidationPage
  },
  {
    key: '/qr/binding',
    label: 'QR Code Binding',
    labelEn: 'QR Code Binding',
    labelZh: 'QR Code绑定',
    hidden: true,
    component: QrCodeBindingPage
  },
  {
    key: '/qr/rfIdScan',
    label: 'RF ID Scan',
    labelEn: 'RF ID Scan',
    labelZh: 'RF ID 箱扫描',
    hidden: true,
    component: rfIdScanningPage
  },
  {
    key: '/qr/unbind/by/carton',
    label: 'QR Code Unbind By Carton',
    labelEn: 'QR Code Unbind By Carton',
    labelZh: 'QR Code按箱解绑',
    hidden: true,
    component: QrCodeUnbindByCartonPage
  },
  {
    key: '/qr/unbind/by/so',
    label: 'QR Code Unbind By SO',
    labelEn: 'QR Code Unbind By SO',
    labelZh: 'QR Code按SO解绑',
    hidden: true,
    component: QrCodeUnbindBySoPage
  },
  {
    key: '/qr/unbind/by/piece',
    label: 'QR Code Unbind By Piece',
    labelEn: 'QR Code Unbind By Piece',
    labelZh: 'QR Code按件解绑',
    hidden: true,
    component: QrCodeUnbindByPiecePage
  },
  // Honeywell（手持枪）
  {
    key: '/rf/reprint/print',
    label: 'RFID Reprint',
    labelEn: 'RFID Reprint',
    labelZh: 'RFID 补打标签',
    hidden: true,
    component: ReprintHoneywellPage
  },
  // 思创（手持枪）
  {
    key: '/rf/reprint/printsc',
    label: 'RFID Reprint',
    labelEn: 'RFID Reprint',
    labelZh: 'RFID 补打标签',
    hidden: false,
    permission: ['menu_rfid_reprint'],
    component: ReprintSCPage
  },
  // Honeywell（手持枪）
  {
    key: '/rf/rfidskucheckhoneywell',
    label: 'RFID SKU Check',
    labelEn: 'RFID SKU Check',
    labelZh: 'RFID SKU 查询',
    hidden: true,
    component: SkuCheckHoneywellPage
  },
  // 思创（手持枪）
  {
    key: '/rf/rfidskuchecksc',
    label: 'RFID SKU Check',
    labelEn: 'RFID SKU Check',
    labelZh: 'RFID SKU 查询',
    hidden: false,
    permission: ['menu_rfid_reprint'],
    component: SkuCheckScPage
  }
]

// 外网访问路由
export const phoneRouterConfigEx = [
  {
    key: '/rf/fulltag',
    label: 'FULL TAG',
    labelEn: 'FULL TAG',
    labelZh: 'FULL绑定',
    hidden: false,
    permission: ['menu_nfc_tag_fullTag'],
    component: FullTagPage
  },
  {
    key: '/rf/nddctag',
    label: 'NDDC TAG',
    labelEn: 'NDDC TAG',
    labelZh: 'NDDC绑定',
    hidden: false,
    permission: ['menu_nfc_tag_nddcTag'],
    component: PFTagPage
  },
  {
    key: '/rfrfid/scan',
    label: 'Grey Market Scan',
    labelEn: 'Grey Market Scan',
    labelZh: 'Grey Market 扫描',
    hidden: false,
    permission: ['menu_greyMarke_greyMarketScan'],
    component: PFRFIDScanPage
  },
  {
    key: '/rfrfid/overdueValidation',
    label: 'Grey Market Scan',
    labelEn: 'WS Defective Return Overdue Validation',
    labelZh: 'WS 残次品退货超期检验',
    hidden: false,
    permission: ['menu_rfid_dr_ws_validation'],
    component: OverdueValidationPage
  },
  // Honeywell（手持枪）
  {
    key: '/rf/reprint/print',
    label: 'RFID Reprint',
    labelEn: 'RFID Reprint',
    labelZh: 'RFID 补打标签',
    hidden: true,
    component: ReprintHoneywellPage
  },
  // 思创（手持枪）
  {
    key: '/rf/reprint/printsc',
    label: 'RFID Reprint',
    labelEn: 'RFID Reprint',
    labelZh: 'RFID 补打标签',
    hidden: false,
    permission: ['menu_rfid_reprint'],
    component: ReprintSCPage
  },
  // Honeywell（手持枪）
  {
    key: '/rf/rfidskucheckhoneywell',
    label: 'RFID SKU Check',
    labelEn: 'RFID SKU Check',
    labelZh: 'RFID SKU 查询',
    hidden: true,
    component: SkuCheckHoneywellPage
  },
  // 思创（手持枪）
  {
    key: '/rf/rfidskuchecksc',
    label: 'RFID SKU Check',
    labelEn: 'RFID SKU Check',
    labelZh: 'RFID SKU 查询',
    hidden: false,
    permission: ['menu_rfid_reprint'],
    component: SkuCheckScPage
  },
  // qa/dev存在，方便外网测试，产线不应存在
  // 开箱检测
  {
    key: '/qr/rfIdScan',
    label: 'RF ID Scan',
    labelEn: 'RF ID Scan',
    labelZh: 'RF ID 箱扫描',
    hidden: true,
    component: rfIdScanningPage
  },
  // qa/dev存在，方便外网测试，产线不应存在
  {
    key: '/qr/binding',
    label: 'QR Code Binding',
    labelEn: 'QR Code Binding',
    labelZh: 'QR Code绑定',
    hidden: true,
    component: QrCodeBindingPage
  },
  // qa/dev存在，方便外网测试，产线不应存在
  {
    key: '/qr/unbind/by/carton',
    label: 'QR Code Unbind By Carton',
    labelEn: 'QR Code Unbind By Carton',
    labelZh: 'QR Code按箱解绑',
    hidden: true,
    component: QrCodeUnbindByCartonPage
  },
  // qa/dev存在，方便外网测试，产线不应存在
  {
    key: '/qr/unbind/by/so',
    label: 'QR Code Unbind By SO',
    labelEn: 'QR Code Unbind By SO',
    labelZh: 'QR Code按SO解绑',
    hidden: true,
    component: QrCodeUnbindBySoPage
  },
  // qa/dev存在，方便外网测试，产线不应存在
  {
    key: '/qr/unbind/by/piece',
    label: 'QR Code Unbind By Piece',
    labelEn: 'QR Code Unbind By Piece',
    labelZh: 'QR Code按件解绑',
    hidden: true,
    component: QrCodeUnbindByPiecePage
  }
]
